import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/breadcrumb/index.js
// module id = 592
// module chunks = 1